// Global chat dock open/close state. Singleton so the TopBar button and the
// dock (mounted once in the AppShell) share it. Ephemeral (not persisted) — the
// assistant panel opens on demand, not by default.
import { ref } from 'vue';

const open = ref(false);

export function useChatDock() {
  function openDock(): void { open.value = true; }
  function closeDock(): void { open.value = false; }
  function toggle(): void { open.value = !open.value; }
  return { open, openDock, closeDock, toggle };
}
